<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_viii"></a><a id="page_ix"></a>For my grandmother Alice Cahill Moore; my parents, Jack and Anne; and my father’s great-aunt, Miss Aggie Blake</p>
<p class="dedicationt">Growing up in Atlanta, I would often hear people say, “Your father has an unusual accent; where is he from?”</p>
<p class="dedication1">May this story provide an answer.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?dedc21f6